import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { IFood } from "../models/IFood";
import { S3_IMAGE_BASE_URL } from "../services/config";
import { useLanguage } from "../context/LanguageContext";
import MobileMenuSearchPopup from "../popupPages/MobileMenuSearchPopup";

interface Props {
  restaurant: IRestaurantDetail;
  foods: IFood[];
  minAmount: number;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  favoriteLoading: boolean;
  loggedIn: boolean;
  orderDisabled: boolean;
}

function MobileRestaurantHeader({ restaurant, foods, minAmount, isFavorite, onToggleFavorite, favoriteLoading, loggedIn, orderDisabled }: Props) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);

  return (
    <>
      {/* Hero resim + overlay bar */}
      <div className="position-relative" style={{ marginTop: "-1rem", marginLeft: "-12px", marginRight: "-12px", background: "#f5f5f5" }}>
        {restaurant.restourantFeatureadImagePath ? (
          <img
            src={S3_IMAGE_BASE_URL + restaurant.restourantFeatureadImagePath}
            alt={restaurant.restourantName}
            style={{ width: "100%", height: "220px", objectFit: "cover", display: "block" }}
          />
        ) : (
          <div style={{ width: "100%", height: "220px", background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {restaurant.restourantLogoPath && (
              <img src={S3_IMAGE_BASE_URL + restaurant.restourantLogoPath} alt={restaurant.restourantName} style={{ maxHeight: "120px", maxWidth: "180px", objectFit: "contain" }} />
            )}
          </div>
        )}
        {/* Ay şeklinde beyaz eğri */}
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, overflow: "hidden", height: 30 }}>
          <svg viewBox="0 0 500 30" preserveAspectRatio="none" style={{ width: "100%", height: "100%", display: "block" }}>
            <ellipse cx="250" cy="30" rx="300" ry="30" fill="#f5f5f5" />
          </svg>
        </div>

        {/* Üst bar: geri + search + favori */}
        <div className="position-absolute w-100 d-flex align-items-center gap-2 px-3" style={{ top: 12 }}>
          <button
            className="d-flex align-items-center justify-content-center"
            style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(0,0,0,0.45)", color: "#fff", border: "none", flexShrink: 0 }}
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <div
            className="flex-grow-1 d-flex align-items-center gap-2"
            style={{ background: "rgba(0,0,0,0.35)", borderRadius: 24, padding: "8px 14px", cursor: "pointer" }}
            onClick={() => setShowSearch(true)}
          >
            <i className="bi bi-search" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.8rem" }}></i>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.8rem" }}>{t("search.placeholder")}</span>
          </div>

          {loggedIn && (
            <button
              className="d-flex align-items-center justify-content-center"
              style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(0,0,0,0.45)", color: "#fff", border: "none", flexShrink: 0 }}
              onClick={onToggleFavorite}
              disabled={favoriteLoading}
            >
              <i className={`bi ${isFavorite ? "bi-heart-fill" : "bi-heart"}`} style={{ color: isFavorite ? "#ff4757" : "#fff" }}></i>
            </button>
          )}
        </div>
      </div>

      {/* Restoran bilgileri */}
      <div className="text-center mt-3 mb-3 px-2">
        <h5 className="fw-bold mb-2">{restaurant.restourantName}</h5>
        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap" style={{ fontSize: "0.78rem", color: "#666" }}>
          {restaurant.restourantTotalFeedBackPoint != null && restaurant.restourantTotalFeedBackPoint > 0 && (
            <span>
              <i className="bi bi-star-fill text-warning me-1"></i>
              {restaurant.restourantTotalFeedBackPoint.toFixed(1)}
            </span>
          )}
          {restaurant.restourantTotalFeedBackPoint != null && restaurant.restourantTotalFeedBackPoint > 0 && <span>·</span>}
          <span>
            <i className={`bi ${restaurant.restourantIsEnabled ? "bi-circle-fill text-success" : "bi-circle-fill text-danger"} me-1`} style={{ fontSize: "0.5rem" }}></i>
            {restaurant.restourantIsEnabled ? t("restaurants.open") : t("restaurants.closed")}
          </span>
          <span>·</span>
          <span>{t("restaurants.minOrder")} {restaurant.restourantMinAmount}₺</span>
          {restaurant.restourantEstDeliveryTime != null && (
            <>
              <span>·</span>
              <span><i className="bi bi-clock me-1"></i>{restaurant.restourantEstDeliveryTime} {t("common.minutes")}</span>
            </>
          )}
        </div>
      </div>

      {showSearch && (
        <MobileMenuSearchPopup
          foods={foods}
          restaurantName={restaurant.restourantName}
          minAmount={minAmount}
          orderDisabled={orderDisabled}
          onClose={() => setShowSearch(false)}
        />
      )}
    </>
  );
}

export default MobileRestaurantHeader;
